export enum RuleMatcher {
    CONTAINS = 'contains',
    STARTS_WITH = 'startsWith',
    ENDS_WITH = 'endsWith',
    EQUALS = 'equals'
}
